import { Subscription } from 'rxjs';
import { Component, OnInit, EventEmitter } from '@angular/core';
import { HttpService, MessageService, SessionService, TableColumns, TableConfiguration, params, MenuBreadCrumb } from 'brainloper-ui';
import { MatDialog } from '@angular/material/dialog';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'app/services/delete-generic.service';
import { SocketWebService } from 'app/services/socket-web.service';
import { EquipmentType } from 'app/models2/maintenance/equipment-type';
import { ResponseType } from 'app/models2/inspections/response-type';
import { Response } from 'app/models2/inspections/response';
import { EPS } from 'app/models2/administration/eps';
import { ARL } from 'app/models2/administration/arl';
import { BaseResponse } from 'app/models2/commos/base-response';
import { UpdateData } from 'app/models2/commos/update-data';
import { GenericResponse } from 'app/models2/commos/generic-response';

@Component({
  selector: 'app-data-root',
  templateUrl: './data-root.component.html',
  styleUrls: ['./data-root.component.scss']
})
export class DataRoMaintenanceOrdersComponent implements OnInit {


  private urlComboTipoRespuesta: string = `${EndpointDictionary.PreopResponseType.PREOP_TYPE_RESPONSE_COMBO}`
  public urlGetDatosTipoRespuesta: string = `${EndpointDictionary.PreopResponseType.PREOP_TYPE_RESPONSE_TABLE}`
  private urlPostTipoRespuesta: string = `${EndpointDictionary.PreopResponseType.CRUD_PREOP_TYPE_RESPONSE_DATA}`
  public urlGetDatosRespuestas: string = `${EndpointDictionary.PreopResponse.PREOP_RESPONSE_TABLE}`
  private  urlPostRespuestas: string = `${EndpointDictionary.PreopResponse.CRUD_PREOP_RESPONSE_DATA}`
  public urlGetDatosArl:string = `${EndpointDictionary.ARL.ARL_TABLE}`
  public urlGetDatosEps:string = `${EndpointDictionary.EPS.EPS_TABLE}`
  private urlCrudEps: string = `${EndpointDictionary.EPS.CRUD_EPS_DATA}`
  private urlCrudArl: string =` ${EndpointDictionary.ARL.CRUD_ARL_DATA}`

  public paramsRespuestas: params[] = [{
    id: "companyId",
    value: 0
  }]

  private paramsComboTipoRespuestas: params[] = [{
    id: "companyId",
    value: 0
  }]

  private companyId: number = 0



  public paramsTipoRespuesta: params[] = [{
    id: "companyId",
    value: 0
  }]

  public paramsEps: params[] = [{
    id:"companyId",
    value:0
    }]

public paramsArl: params[] = [{
      id:"companyId",
      value:0
      }]




  //Tabla Tipo Equipos
  public columnasTipoEquipo: TableColumns<EquipmentType>[] = [
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        width: '50%'
      }
    }

  ]
  public dataTipoEquipo: Array<EquipmentType> = []
  recargarTablaTipoEquipo = new EventEmitter<any>()

  public configurationTipoEquipo: TableConfiguration = {
    add: true,
    edit: true,
    delete: true,
    primaryKey: 'id'
  }

  //Tabla Tipo respuesta
  public columnasTipoRespuesta: TableColumns<ResponseType>[] = [
    {
      ID: 'responseType',
      label: 'tipo respuesta',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '50%'
      }
    }

  ]
  public dataTipoRespuesta: Array<ResponseType> = []
  recargarTablaTipoRespuesta = new EventEmitter<any>()

  public configurationTipoRespuesta: TableConfiguration = {
    add: true,
    edit: true,
    delete: true,
    primaryKey: 'id'
  }


   //Tabla respuesta
   public columnasRespuestas: TableColumns<Response>[] = [
    {
      ID: 'responseType',
      label: 'tipo respuesta',
      type: 'combo',
      paramsCombo: {
        url:this.urlComboTipoRespuesta,
        urlParams:this.paramsComboTipoRespuestas,
        selectionField:'id',
        visibleField:'responseType'
      },
      style: {
        textAlign: 'center',
        width: '50%'
      }
    },
    {
      ID:'response',
      label: 'Respuesta',
      type: 'text',
      style:{
        textAlign: 'center',
        width: '50%'
      }
    }

  ]
  public dataRespuestas: Array<Response> = []
  recargarTablaRespuestas = new EventEmitter<any>()

  public configurationRespuestas: TableConfiguration = {
    add: true,
    edit: true,
    delete: true,
    primaryKey: 'id'
  }


    //Tabla EPS
    public columnasEps: TableColumns<EPS>[] = [
      {
        ID: 'name',
        label: 'Nombre',
        type: 'text',
        style: {
          textAlign: 'center',
          width: '50%'
        }
      },
      {
        ID: 'contactNumber',
        label: 'Contacto',
        type: 'text',
        style: {
          textAlign: 'center',
          width: '50%'
        }
      },

    ]
    public recargarTablaEps = new EventEmitter<any>()

    public configurationEps: TableConfiguration = {
      add: true,
      edit: true,
      delete: true,
      primaryKey:'id',
    }

    //Tabla ARL
    public columnasArl: TableColumns<ARL>[] = [
      {
        ID: 'name',
        label: 'Nombre',
        type: 'text',
        style: {
          textAlign: 'center',
          width: '50%'
        }
      },
      {
        ID: 'contact',
        label: 'Contacto',
        type: 'text',
        style: {
          textAlign: 'center',
          width: '50%'
        }
      },

    ]
    public recargarTablaArl = new EventEmitter<any>()

    public configurationArl: TableConfiguration = {
      add: true,
      edit: true,
      delete: true,
      primaryKey:'id',
    }

    public menuBreadCrumb:Array<MenuBreadCrumb> = [
      {
        name:"Inicio",
        router:'/inicio',
      },
      {
      name:"Datos Mantenimiento",
      current:true
    }]


  constructor(
    private http: HttpService,
    public dialog: MatDialog,
    private message: MessageService,
    private deleteItem: DeleteGenericService,
    private socketWebService : SocketWebService
  ) { }

  ngOnInit(): void {
  }

  //CRUD TIPO RESPUESTA

  agregarTipoRespuesta($event) {
    this.message.openLoading('Cargando', 'Creando Tipo Respuesta')
    let form = {
      "companyId": this.companyId,
      "responseType": $event.responseType
    }
    //console.log(form)

    this.http.postData(`${this.urlPostTipoRespuesta}`, form).subscribe(
      (res: BaseResponse<ResponseType>) => {

        this.recargarTablaTipoRespuesta.emit()

        if (res['code'] === 0) {
          this.message.SuccessToast(res['message'])
          this.message.closeLoading()
        } else {
          this.message.Error('Error!', `Código: ${res['code']} - Mensaje : ${res['code']}`)
        } err => {
          this.message.Error('Error!', err.message)
        }

      }
    )

  }

  editarTipoRespuesta($event: UpdateData<ResponseType>) {
    this.message.openLoading('Cargando', 'Actualizando tipo respuesta')
    let form = {
      "id": $event.old.id,
      "responseType": $event.new.responseType,
      "companyId": this.companyId
    }

    this.http.putData(`${this.urlPostTipoRespuesta}`, form).subscribe(
      (res: BaseResponse<GenericResponse>) => {

        this.recargarTablaTipoRespuesta.emit()

        if (res['code'] === 0) {
          this.message.SuccessToast(res['message'])
          this.message.closeLoading()
        } else {
          this.message.Error('ERROR!', `Código: ${res['code']} - Mensaje : ${res['code']}`)
        } err => {
          this.message.Error('Error!', err.message)
        }
      }
    )

  }

  async eliminarTipoRespuesta($event: ResponseType[]) {
    let res =  await this.deleteItem.deleteD($event, this.urlPostTipoRespuesta, "id")
    this.recargarTablaTipoRespuesta.emit()
  }

       //CRUD Respuestas

       agregarRespuestas($event: Response) {
         this.message.openLoading('Cargando', 'Creando respuesta')
        let form = {
          "companyId": this.companyId,
          "responseTypeId": $event.responseType,
          "response": $event.response 
        }
        //console.log(form)

        this.http.postData(`${this.urlPostRespuestas}`, form).subscribe(
          (res: BaseResponse<GenericResponse>) => {

            this.recargarTablaRespuestas.emit()

            if (res['code'] === 0) {
              this.message.SuccessToast(res['message'])
              this.message.closeLoading()
            } else {
              this.message.Error('Error!', `Código: ${res['code']} - Mensaje : ${res['code']}`)
            } err => {
              this.message.Error('Error!', err.message)
            }
          }
        )
      }

      editarRespuestas($event: UpdateData<Response>) {
        this.message.openLoading('Cargando', 'Actualizando respuesta')
        let form = {
          "id": $event.old.id,
          "responseTypeId": $event.new.responseType,
          "companyId": this.companyId,
          "response": $event.new.response
        }

        this.http.putData(`${this.urlPostRespuestas}`, form).subscribe(
          (res: BaseResponse<GenericResponse>) => {

            this.recargarTablaRespuestas.emit()

            if (res['code'] === 0) {
              this.message.SuccessToast(res['message'])
              this.message.closeLoading()
            } else {
              this.message.Error('ERROR!', `Código: ${res['code']} - Mensaje : ${res['code']}`)
            } err => {
              this.message.Error('Error!', err.message)
            }
          }
        )
      }

      async eliminarRespuestas($event: Response[]) {
        let res =  await this.deleteItem.deleteD($event, this.urlPostRespuestas, "id")
        this.recargarTablaRespuestas.emit()
      }

      //CRUD EPS

  agregarEps($event: EPS) {

    this.message.openLoading('Cargando', 'Creando EPS')

    let eps: EPS = {
      "companyId": this.companyId,
      "name": $event.name,
      "contactNumber": $event.contactNumber
    }


    this.http.postData(`${EndpointDictionary.EPS.CRUD_EPS_DATA}`, eps).subscribe(
      (res: BaseResponse<GenericResponse>) => {

        this.recargarTablaEps.emit()

        if (res['code'] === 0) {
          this.message.SuccessToast('EPS creada correctamente')
          this.message.closeLoading()
        } else {
          this.message.Error('Error!', `Código: ${res['code']} - Mensaje : ${res['code']}`)
        } err => {
          this.message.Error('Error!', err.message)
        }

      }
    )
  }

  editarEps($event: UpdateData<EPS>) {
    this.message.openLoading('Cargando', 'Editando EPS')
    ////console.log($event)
    let eps: EPS = {
      "id": $event.old.id,
      "name": $event.new.name,
      "contactNumber": $event.new.contactNumber
    }


    this.http.putData(`${EndpointDictionary.EPS.CRUD_EPS_DATA}`, eps).subscribe(
      (res: BaseResponse<GenericResponse>) => {

        this.recargarTablaEps.emit()

        if (res['code'] === 0) {
          this.message.SuccessToast('EPS actualizada correctamente')
          this.message.closeLoading()
        } else {
          this.message.Error('ERROR!', `Código: ${res['code']} - Mensaje : ${res['code']}`)
        } err => {
          this.message.Error('Error!', err.message)
        }
      }
    )
  }

  async eliminarEps($event: EPS[]) {

    let res =  await this.deleteItem.deleteD($event, this.urlCrudEps, "id", "EPS", "las EPS")
    this.recargarTablaEps.emit()
  }

  //CRUD ARL

  agregarArl($event: ARL) {
    this.message.openLoading('Cargando', 'Creando ARL')
    let arl: ARL = {
      "companyId": this.companyId,
      "name": $event.name,
      "contact": $event.contact
    }

    this.http.postData(`${EndpointDictionary.ARL.CRUD_ARL_DATA}`, arl).subscribe(
      (res: BaseResponse<GenericResponse>) => {

        this.recargarTablaArl.emit()

        if (res['code'] === 0) {
          this.message.SuccessToast('ARL creada correctamente')
          this.message.closeLoading()
        } else {
          this.message.Error('Error!', `Código: ${res['code']} - Mensaje : ${res['code']}`)
        } err => {
          this.message.Error('Error!', err.message)
        }

      }
    )
  }

  editarArl($event: UpdateData<ARL>) {
    this.message.openLoading('Cargando','Editando ARL')
    let arl: ARL = {
      "id": $event.old.id,
      "name": $event.new.name,
      "contact": $event.new.contact
    }

    this.http.putData(`${EndpointDictionary.ARL.CRUD_ARL_DATA}`, arl).subscribe(
      (res: BaseResponse<GenericResponse>) => {

        this.recargarTablaArl.emit()

        if (res['code'] === 0) {
          this.message.SuccessToast('ARL actualizado correctamente')
          this.message.closeLoading()
        } else {
          this.message.Error('ERROR!', `Código: ${res['code']} - Mensaje : ${res['code']}`)
        } err => {
          this.message.Error('Error!', err.message)
        }

      }
    )
  }

  async eliminarArl($event: ARL[]) {
    let res =  await this.deleteItem.deleteD($event, this.urlCrudArl, "id", "ARL", "las ARL")
    this.recargarTablaArl.emit()
  }

  handlerVersion(){
    this.message.Warning('Advertencia', 'Desea envia envento de actualización', true).then( res => {
      if(res){
        this.socketWebService.emit('generate-new-version', true)
      }
    })
  }
}
